import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "10"
}), 'Brightness1Rounded');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Brightness1Rounded.js
// module id = 2475
// module chunks = 2